import SVGInline from 'react-svg-inline';
import { useSelector } from 'react-redux';

import { getIsEffectiveDateReport } from 'selectors/property-explorer';

import layersIcon from 'legacy/assets/svg-inline/layers.svg';
import drawIcon from 'legacy/assets/svg-inline/draw-icon.svg';

import { MapControlToggleButtons as theme } from 'legacy/css-modules';

const MapControlToggleButtons = ({
  showControlLayers,
  showControlDraw,
  onShowControlsClickLayers,
  onShowControlsClickDraw,
  qaSelectorSuffix = ''
}) => {
  const isEffectiveDateReport = useSelector(getIsEffectiveDateReport);
  if (isEffectiveDateReport) return null;
  return (
    <div className={theme.Component}>
      {showControlLayers && (
        <div
          className="show-map-controls-button"
          onClick={onShowControlsClickLayers}
          data-hc-name={`map-layer-controls-toggle-button${qaSelectorSuffix}`}
        >
          <SVGInline svg={layersIcon} />
        </div>
      )}
      {showControlDraw && (
        <div
          className="show-map-controls-button"
          onClick={onShowControlsClickDraw}
          data-hc-name={`map-draw-controls-toggle-button${qaSelectorSuffix}`}
        >
          <SVGInline svg={drawIcon} style={{ marginTop: '-4px' }} />
        </div>
      )}
    </div>
  );
};

export default MapControlToggleButtons;
